import { BaseApi } from "../BaseApi";
import { InterceptToken } from "../../interceptors/TokenInterceptor";

const crearAutorizacionUrl = "api/v1/websalud/primeraars/sesion/cierre";
const registrarInfoAutorizacionUrl =
  "api/v1/websalud/primeraars/autorizaciones/informacion";
const subirArchivoAutorizacionUrl =
  "api/v1/websalud/primeraars/autorizaciones/soporte";
const getAutorizacionesUrl = "api/v1/websalud/primeraars/autorizaciones";
const getInfoAutorizacionUrl =
  "api/v1/websalud/primeraars/autorizaciones/informacion";

const modificarDiagnosticoDefinitivoUrl =
  "api/v1/websalud/primeraars/autorizaciones/diagnosticodefinitivo/modificar";

const reactivarAutorizacionUrl = "api/v1/websalud/primeraars/sesion/reinicio";

const consultarAutorizacionHijaUrl =
  "api/v1/websalud/primeraars/autorizaciones/hija";

const getDetalleAutorizacionUrl = (request) =>
  `api/v1/websalud/primeraars/autorizaciones/${request.numeroAutorizacion}`;

const cancelarAutorizacionUrl = (request) =>
  `api/v1/websalud/primeraars/autorizaciones/${request.numeroAutorizacion}/cancelacion`;

const crearAutorizacion = (request) =>
  InterceptToken(
    BaseApi.post,
    crearAutorizacionUrl,
    request.requestData,
    request.requestHeaders
  ).then((response) => response.data);

const cancelarAutorizacion = (request) =>
  InterceptToken(
    BaseApi.post,
    cancelarAutorizacionUrl(request.requestData),
    {
      numeroPlastico: request?.requestData?.numeroPlastico,
      codigoMotivo: request?.requestData?.codigoMotivo,
    },
    request.requestHeaders
  ).then((response) => response.data);

const reactivarAutorizacion = (request) =>
  InterceptToken(BaseApi.post, reactivarAutorizacionUrl, request).then(
    (response) => response.data
  );

const registrarInfoAutorizacion = (request) =>
  InterceptToken(BaseApi.post, registrarInfoAutorizacionUrl, request).then(
    (response) => response.data
  );

const getInfoAutorizacion = (request) =>
  InterceptToken(BaseApi.get, getInfoAutorizacionUrl, request).then(
    (response) => response.data
  );

const subirArchivoAutorizacion = (request) =>
  InterceptToken(BaseApi.post, subirArchivoAutorizacionUrl, request).then(
    (response) => response.data
  );

const getAutorizaciones = (request) =>
  InterceptToken(BaseApi.get, getAutorizacionesUrl, request).then(
    (response) => response.data
  );

const getDetalleAutorizacion = (request) =>
  InterceptToken(BaseApi.get, getDetalleAutorizacionUrl(request), request).then(
    (response) => response.data
  );

const consultarAutorizacionHija = (request) =>
  InterceptToken(BaseApi.get, consultarAutorizacionHijaUrl, request).then(
    (response) => response.data
  );

const modificarDiagnosticoDefinitivo = (request) =>
  InterceptToken(BaseApi.post, modificarDiagnosticoDefinitivoUrl, request).then(
    (response) => response.data
  );

const exportedObject = {
  crearAutorizacion,
  cancelarAutorizacion,
  reactivarAutorizacion,
  registrarInfoAutorizacion,
  subirArchivoAutorizacion,
  getAutorizaciones,
  getDetalleAutorizacion,
  getInfoAutorizacion,
  consultarAutorizacionHija,
  modificarDiagnosticoDefinitivo,
};

export default exportedObject;
